import { gql } from '@apollo/client'

export const MUTATION_ADD_TAGS_FOR_CASE_ITEMS = gql`
  mutation mutationAddTagsForCaseItems($input: AddTagsForCaseItemsInput!) {
    addTagsForCaseItems(input: $input) {
      items {
        id
        color
        name
        taggable_id
        taggable_type
      }
    }
  }
`
